// Turns long policy text (Return policy page, /policies/privacy-policy, /policies/terms-of-service) into numbered
// section cards with a sticky "On this page" menu. Headings split the sections; with no usable headings the text is left as is.
// Hero label and subtitle that fit each policy page (same look as the Return Policy hero).
const heroText = {
  'privacy-policy': ['Privacy', 'How we collect, use and protect your personal information.'],
  'terms-of-service': ['Terms & conditions', 'The terms that apply when you shop with Mr. Energy Cellphones LLC.'],
  'refund-policy': ['Returns', 'What to expect if you need to return or exchange an item.'],
  'shipping-policy': ['Shipping', 'How your order gets from our store to your door.'],
};
const policyTitle = document.querySelector('.shopify-policy__title');
if (policyTitle && !policyTitle.querySelector('.about-hero__eyebrow')) {
  const slug = window.location.pathname.split('/').filter(Boolean).pop();
  const [label, line] = heroText[slug] || ['Our policy', 'Clear and simple, so you always know where you stand.'];
  const heading = policyTitle.querySelector('h1');
  const eyebrow = document.createElement('p');
  eyebrow.className = 'about-hero__eyebrow';
  eyebrow.textContent = label;
  const subtitle = document.createElement('p');
  subtitle.className = 'about-hero__subtitle policy-hero-subtitle';
  subtitle.textContent = line;
  policyTitle.prepend(eyebrow);
  heading?.after(subtitle);
}

const root = document.querySelector('[data-policy-source]') || document.querySelector('.shopify-policy__body');

function clean(text) {
  return text.trim().replace(/^\d+(\.\d+)*\.?\s*/, '').replace(/:\s*$/, '');
}

if (root) {
  const source = root.querySelector('.rte') || root;
  // Shopify wraps policy text in extra <div>s; the real content sits one or two levels down.
  let content = source;
  while (content.children.length === 1 && content.firstElementChild.tagName === 'DIV') content = content.firstElementChild;
  const nodes = Array.from(content.children);
  const level = ['H2', 'H3', 'H1'].find((tag) => nodes.filter((n) => n.tagName === tag).length >= 2);
  if (level) {
    const intro = [];
    const sections = [];
    nodes.forEach((node) => {
      if (node.tagName === level) sections.push({ title: node.textContent, body: [] });
      else if (sections.length) sections[sections.length - 1].body.push(node);
      else intro.push(node);
    });

    const layout = document.createElement('div');
    layout.className = 'policy-layout';
    const nav = document.createElement('nav');
    nav.className = 'policy-nav';
    nav.setAttribute('aria-label', 'On this page');
    nav.innerHTML = '<p class="policy-nav__label">On this page</p>';
    const cards = document.createElement('div');
    cards.className = 'policy-cards';

    // Make the "Last updated" line stand out.
    intro.forEach((n) => {
      if (/^\s*last updated/i.test(n.textContent) && !n.querySelector('strong')) n.innerHTML = `<strong>${n.innerHTML}</strong>`;
    });
    const introHasText = intro.some((n) => n.textContent.trim().length > 0);
    if (introHasText) {
      const card = document.createElement('section');
      card.className = 'policy-card policy-card--intro';
      card.setAttribute('data-reveal', '');
      intro.forEach((n) => card.append(n));
      cards.append(card);
    }

    sections.forEach((section, index) => {
      const id = `policy-section-${index + 1}`;
      const card = document.createElement('section');
      card.className = 'policy-card';
      card.id = id;
      card.setAttribute('data-reveal', '');
      card.style.setProperty('--reveal-delay', `${Math.min(index, 4) * 0.05}s`);
      const head = document.createElement('header');
      head.className = 'policy-card__head';
      head.innerHTML = `<span class="policy-card__number">${index + 1}</span><h2 class="policy-card__title"></h2>`;
      head.querySelector('h2').textContent = clean(section.title);
      const body = document.createElement('div');
      body.className = 'policy-card__body';
      section.body.forEach((n) => body.append(n));
      card.append(head, body);
      cards.append(card);

      const link = document.createElement('a');
      link.href = `#${id}`;
      link.dataset.target = id;
      link.innerHTML = `<span>${index + 1}</span>${clean(section.title)}`;
      nav.append(link);
    });

    layout.append(nav, cards);
    source.replaceChildren(layout);
    root.classList.add('is-enhanced');

    // Reveal + highlight the section in view.
    const links = Array.from(nav.querySelectorAll('a'));
    const spy = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) links.forEach((l) => l.classList.toggle('is-active', l.dataset.target === entry.target.id));
      });
    }, { rootMargin: '-20% 0px -65% 0px' });
    cards.querySelectorAll('.policy-card[id]').forEach((card) => spy.observe(card));
    import('./reveal.js');
  }
}
